export var SUBMIT_BUTTON_DEFAULT_TEXT = 'Submit';
export var CARD_ELEMENT_STYLE = {
  base: {
    color: '#000000',
    fontSize: '16px',
    '::placeholder': {
      color: '#999',
      fontSize: '16px'
    }
  }
};